/**
 * An array that only remembers the last N items pushed onto it
 * Example:
 *   const recentMeasurements = new ForgetfulArray(2);
 *   recentMeasurements.push(5);
 *   recentMeasurements.push(10);
 *   recentMeasurements.push(15);
 *   // See that the oldest measurement of 5 was forgotten when 15 got pushed on
 *   recentMeasurements.items
 *   // => [10, 15]
 */
export class ForgetfulArray<T> {
  public numberOfRecentItemsToRemember: number | null;

  private itemsRemembered: T[];

  /**
   *
   * @param {number|null} numberOfRecentItemsToRemember If null, then remember all items pushed onto
   * the array. Otherwise, remember only the last N items pushed onto the array.
   */
  constructor(numberOfRecentItemsToRemember: number | null = null) {
    this.numberOfRecentItemsToRemember = numberOfRecentItemsToRemember;
    this.itemsRemembered = [];
  }

  push(newItem: T) {
    if (
      this.numberOfRecentItemsToRemember &&
      this.itemsRemembered.length >= this.numberOfRecentItemsToRemember
    ) {
      this.itemsRemembered = this.itemsRemembered.slice(1);
    }

    this.itemsRemembered.push(newItem);
  }

  get items() {
    return this.itemsRemembered;
  }
}
